var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AsiContentContainer',{attrs:{"no-bottom-margin":""}},[(_vm.item !== null)?_c('CustomerItemList',{attrs:{"item-model":_vm.item}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }